import { render, staticRenderFns } from "./BusinessBox.vue?vue&type=template&id=82579990&scoped=true&"
import script from "./BusinessBox.vue?vue&type=script&lang=ts&"
export * from "./BusinessBox.vue?vue&type=script&lang=ts&"
import style0 from "./BusinessBox.vue?vue&type=style&index=0&id=82579990&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82579990",
  null
  
)

export default component.exports